export default "__VITE_ASSET__CdICOKME__"